import React from "react";
import "../styles/airtel.css";
function AirtelVerification() {
  return (
    <section className="inner-work inner-bx top-sb">
      <div className="container">
        <h2>Airtel Verification</h2>
        <h4>Airtel Verification Process</h4>

        <div className="process-block">
          <h4>Airtel Verification Home</h4>

          <img src="/images/image nitish/Matrix/AirtelLogin.png" alt="Airtel Login" />
          <img src="/images/image nitish/Matrix/AirtelHome1.png" alt="Airtel Home1" />
          <img src="/images/image nitish/Matrix/AirtelHome2.png" alt="Airtel Home2" />
        </div>

        <div className="process-block">
          <h4>Airtel Verification Screen</h4>

          <img src="/images/image nitish/Matrix/AirtelScreen1.png" alt="Screen1" />
          <img src="/images/image nitish/Matrix/AirtelScreen.png" alt="Screen2" />
        </div>

        <div className="process-block">
          <h4>Airtel Verification Reports</h4>

          <img src="/images/image nitish/Matrix/AirtelReports.png" alt="Reports1" />
          <img src="/images/image nitish/Matrix/AirtelReports1.png" alt="Reports2" />
        </div>
      </div>
    </section>
  );
}

export default AirtelVerification;